import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weixin",
  "use": "icon-weixin-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-weixin\">\n  <defs>\n    <style>\n      #icon-weixin .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-weixin_weixin\" class=\"cls-1\" d=\"M1044,1013a10.834,10.834,0,0,1-3.25-.5L1037,1015v-4.58a8.539,8.539,0,0,1-3-6.42c0-4.971,4.48-9,10-9s10,4.029,10,9S1049.52,1013,1044,1013Zm-4-10,2,2,12-6v1l-12,7-3-3Z\" transform=\"translate(-1034 -995)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/weixin.svg
// module id = E+Kt
// module chunks = 69